export const sortByKey = (arr = [], key) => {
  return arr.slice().sort((a, b) => {
    const valA = key ? a[key] : a;
    const valB = key ? b[key] : b;

    return String(valA).localeCompare(String(valB));
  });
};
